import script from "./Register.vue?vue&type=script&setup=true&lang=ts"
export * from "./Register.vue?vue&type=script&setup=true&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=097f9936&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-097f9936"]])

export default __exports__